import * as z from "zod";

export const disconnectBubblehouseIntegration = {
  name: "disconnectBubblehouseIntegration" as const,
  input: z.object({}),
  output: z.object({}),
};
